export default "__VITE_ASSET__BegV8iwf__"